import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import { useGetVideosQuery } from "../../redux/features/videos/videosAPI";
import { useAddQuizMutation } from "../../redux/features/quiz/quizAPI";
import { userLoggedOut } from "../../redux/features/auth/authSlice";
import Error from "../../components/Error";
import usePageTitle from "../../utils/usePageTitle";

export default function AddQuiz() {
  usePageTitle("Add Quiz");
  const navigate = useNavigate();
  const dispatch = useDispatch();

  useEffect(() => {
    const { role } = JSON.parse(localStorage.auth).user;

    if (role !== "admin") {
      navigate("/admin");

      dispatch(userLoggedOut());
      window.localStorage.clear();
    }
  }, [dispatch, navigate]);

  const {
    data: videos,
    isLoading: videoIsLoading,
    isError: videoIsError,
  } = useGetVideosQuery();

  const [addQuiz, { isLoading, error }] = useAddQuizMutation();

  const [question, setQuestion] = useState("");
  const [video, setVideo] = useState({});

  const [options1, setOptions1] = useState({});
  const [options2, setOptions2] = useState({});
  const [options3, setOptions3] = useState({});
  const [options4, setOptions4] = useState({});

  const handleSubmit = (e) => {
    e.preventDefault();

    addQuiz({
      question,
      options: [options1, options2, options3, options4],
      video_id: video.id,
      video_title: video.title,
    });

    navigate("/admin/quizzes");
  };

  return (
    <div
      style={{
        minWidth: "50%",
        position: "absolute",
        top: "45%",
        left: "50%",
        transform: "translate(-50%, -50%)",
      }}
      className="container relative"
    >
      <div>
        <h2 className="mt-6 text-center text-3xl font-bold text-cyan">
          Add New Quiz
        </h2>
      </div>

      <form className="mt-8 space-y-6" onSubmit={(e) => handleSubmit(e)}>
        <div className="rounded-md shadow-sm -space-y-px">
          <div>
            <div>
              <label
                htmlFor="video"
                className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
              >
                Associated Video
              </label>
              <select
                name="associatedVideo"
                required
                style={{
                  color: "white",
                  width: "100%",
                  backgroundColor: "rgb(30 41 59 / var(--tw-bg-opacity))",
                  height: "40px",
                  fontSize: "0.875rem",
                  padding: "10px",
                }}
                className="px-3 rounded-md mt-1"
                onChange={(e) =>
                  setVideo(
                    videos.find((video) => video.title === e.target.value)
                  )
                }
              >
                <option value="" hidden selected>
                  Select Associated Video
                </option>
                {!videoIsLoading &&
                  !videoIsError &&
                  videos.map((video) => (
                    <option key={video.id}>{video.title}</option>
                  ))}
              </select>
            </div>

            <label
              htmlFor="title"
              className="block mb-2 text-sm font-medium text-gray-900 dark:text-gray mt-4"
            >
              Question
            </label>
            <input
              id="question"
              name="question"
              type="text"
              autoComplete="question"
              required
              className="login-input rounded-md mt-1"
              placeholder="Question"
              value={question}
              onChange={(e) => setQuestion(e.target.value)}
            />
          </div>

          <br />

          {/* options start here */}

          <label
            htmlFor="options"
            className="block mb-2 text-sm font-medium text-gray-900 dark:text-white pb-4"
          >
            Options
          </label>
          <div
            className="flex"
            onChange={(e) =>
              setOptions1((prev) => ({
                id: 1,
                option: e.target.type === "text" ? e.target.value : prev.option,
                isCorrect:
                  e.target.type === "checkbox" && e.target.checked
                    ? true
                    : false,
              }))
            }
          >
            <label htmlFor="Marks" className="sr-only">
              Options 1
            </label>
            <input type="checkbox" /> &nbsp;&nbsp;{" "}
            <input
              id="options"
              name="options 1"
              type="text"
              autoComplete="options 1"
              required
              className="login-input rounded-md"
              placeholder="Option 1 (Select checkbox if true)"
            />
          </div>

          <div
            className="flex"
            onChange={(e) =>
              setOptions2((prev) => ({
                id: 2,
                option: e.target.type === "text" ? e.target.value : prev.option,
                isCorrect:
                  e.target.type === "checkbox" && e.target.checked
                    ? true
                    : false,
              }))
            }
          >
            <label htmlFor="Marks" className="sr-only">
              Options 2
            </label>
            <input type="checkbox" /> &nbsp;&nbsp;
            <input
              id="options"
              name="options 2"
              type="text"
              autoComplete="options 2"
              required
              className="login-input rounded-md mt-2"
              placeholder="Option 2 (Select checkbox if true)"
            />
          </div>

          <div
            className="flex"
            onChange={(e) =>
              setOptions3((prev) => ({
                id: 3,
                option: e.target.type === "text" ? e.target.value : prev.option,
                isCorrect:
                  e.target.type === "checkbox" && e.target.checked
                    ? true
                    : false,
              }))
            }
          >
            <label htmlFor="Marks" className="sr-only">
              Options 3
            </label>
            <input type="checkbox" /> &nbsp;&nbsp;
            <input
              id="options"
              name="options 3"
              type="text"
              autoComplete="options 3"
              required
              className="login-input rounded-md mt-2"
              placeholder="Option 3 (Select checkbox if true)"
            />
          </div>

          <div
            className="flex"
            onChange={(e) =>
              setOptions4((prev) => ({
                id: 4,
                option: e.target.type === "text" ? e.target.value : prev.option,
                isCorrect:
                  e.target.type === "checkbox" && e.target.checked
                    ? true
                    : false,
              }))
            }
          >
            <label htmlFor="Marks" className="sr-only">
              Options 4
            </label>
            <input type="checkbox" /> &nbsp;&nbsp;
            <input
              id="options"
              name="options 4"
              type="text"
              autoComplete="options 4"
              required
              className="login-input rounded-md mt-2"
              placeholder="Option 4 (Select checkbox if true)"
            />
          </div>
        </div>

        <div className="flex justify-end gap-x-2">
          <button
            type="submit"
            disabled={isLoading}
            className="py-2 px-4 border border-transparent text-sm font-medium rounded-md text-white bg-violet-600 hover:bg-violet-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-violet-500"
          >
            Save
          </button>

          <Link
            to="/admin/quizzes"
            type="submit"
            disabled={isLoading}
            className="py-2 px-4 border border-transparent text-sm font-medium rounded-md text-white bg-red-600 hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500"
          >
            Cancel
          </Link>
        </div>
        {error && <Error error={error} />}
      </form>
    </div>
  );
}
